<template>
   <v-container>
    <v-layout row justify-center>
      <v-flex xs12 md5 class="grey lighten-4">
        <v-container>
          <v-card>
            <v-card-title>
              Login voor de Leiding
            </v-card-title>
            <v-form ref="login" @submit.prevent="login">
            <v-card-text class="mx-15">
              <v-text-field :rules="emailRules" prepend-icon="mail" v-model="email" label="email"></v-text-field>
              <v-text-field
                  :rules="required"
                  prepend-icon="lock"
                  :append-icon="showpwd ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showpwd ? 'text' : 'password'"
                  label="wachtwoord"
                  v-model="password"
                  class="input-group--focused"
                  @click:append="showpwd = !showpwd"
                  @keyup.enter="login"
              ></v-text-field>
              <span class="red--text caption"> {{feedback}} </span>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="login" :loading="loading" large block color="orange lighten-4">Login</v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from '@/firebase/init'
export default {
  name: 'LedenLogin',
  data() {
    return {
      emailRules: [
          v => !!v || 'E-mail is verplicht',
          v => /.+@.+\..+/.test(v) || 'voer een geldig emailadres in',
      ],
      required: [
          v => !!v || 'Wachtwoord is verplicht'
      ],

      loading: false,
      showpwd: null,
      password: null,
      email: null,
      feedback: null
    }
  },
  methods: {
    login() {
      if(this.$refs.login.validate()){
        this.loading = true;
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(() => {
          this.loading = false;
          this.$router.push( {name: 'LeidingsPagina'} )
        }).catch((e) => {
          this.feedback = e.message;
          this.loading = false;
        });
      }
    }
  }
}
</script>

<style>

</style>